module.exports = __webpack_public_path__ + "static/media/Streaker.49259b6e.svg";